import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { useQuery, useLazyQuery, useMutation } from '@apollo/client';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import 'react-grid-layout/css/styles.css';
import { Responsive as ResponsiveGridLayout } from 'react-grid-layout';
import { v4 as uuidv4 } from 'uuid';

import { GET_CARDHOLDERS, GET_PRS, ADD_WIDGET, UPDATE_PR, ADD_PR } from '../util/schema';
import ButtonHeader from './ButtonHeader.jsx';

const useStyles = makeStyles((theme, props) => ({
  paper: {
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
    height: '78vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    width: '100%',
  },
  header: {
    fontSize: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(2),
    },
    color: theme.palette.header.main,
  },
  form: {
    textAlign: 'center',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    flexWrap: 'wrap',
    maxWidth: '100%',
  },
  imageContainer: {
    minWidth: '5vw',
    width: 'min-content',
    objectFit: 'contain',
  },
  widget: {
    backgroundColor: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  gridleft: {
    alignContent: 'center',
    margin: 'auto',
    position: 'absolute',
    left: '4%',
  },
  gridright: {
    alignContent: 'center',
    margin: 'auto',
    display: 'flex',
    position: 'relative',
    left: (props) => (props.left ? props.left : '20%'),
    justifyContent: (props) => (props.justify ? props.justify : ''),
    bottom: (props) => (props.bottom ? props.bottom : ''),
  },
}));

const PhotoRecall = () => {
  const [photoRecallWidgets, setPhotoRecallWidgets] = useState([]);
  const [configuration, setConfiguration] = useState(1);
  const [gridsize, setGridsize] = useState(4);
  const [layout, setLayout] = useState(
    '[{"w":1,"h":3,"x":0,"y":0,"i":"b7f5b215-2bb7-4061-851b-8027f84984a0","":false,"static":true,"isResizable":false},{"w":1,"h":3,"x":1,"y":0,"i":"b34ee8c6-64e8-485c-ba59-dedeec028250","moved":false,"static":true,"isResizable":false},{"w":1,"h":3,"x":2,"y":0,"i":"88c5a6e0-f354-41ee-ac2a-98b244d31ce6","moved":false,"static":true,"isResizable":false},{"w":1,"h":3,"x":3,"y":0,"i":"7b5cd475-7b01-48e1-8355-27e83b5e8bb2","moved":false,"static":true,"isResizable":false}]'
  );
  const [prsize, setPRSize] = useState(2);
  const [cardholderdata, setcurrentcardData] = useState({});

  const [props, setProps] = useState({});

  const classes = useStyles(props);
  const [gridarray, setGridArray] = useState(['Apple', 'Orange', 'Pear', 'Strawberry']);
  const [newPRwidget, setnewPRWidget] = useState();
  const [customField, setCustomField] = useState(false);

  const [customGridSize, setCustomGridSize] = useState(4);
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [count, setCount] = useState(0);
  const [layouthandler, setLayouthandler] = useState(1);
  const [prID, setPRID] = useState();
  const [wID, setwID] = useState();
  const [PRwidgetInput, setPRWidgetInput] = useState();
  const [widgetInput, setwidgetInput] = useState();
  let gridlayout;

  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackBarOpen(false);
    if (newPRwidget) {
      addWidget();
    } else {
      updatePR();
    }
  };

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const queryCompleted = (data) => {
    setcurrentcardData(data);
    getPRs();
  };

  const queryError = ({ graphQLErrors, networkError }) => {
    console.log(graphQLErrors);
    console.log(networkError);
  };

  const { data, loading, error, refetch } = useQuery(GET_CARDHOLDERS, {
    variables: { first: 1000, skip: count },
    notifyOnNetworkStatusChange: true,
    onCompleted: queryCompleted,
    onError: queryError,
  });

  const getWidgetscompleted = (data) => {
    const carddata = cardholderdata;

    const widgetdata = data.photoRecallData.photoRecallWidgets;

    let photoArry = { hover: false };
    photoArry = carddata.cardholders.edges
      .map((cardholder) => {
        return { ...cardholder, hover: false };
      })
      .filter((cardholder) => cardholder.lastActivity != null)
      .sort((a, b) => {
        const aDate = new Date(a.lastActivity);
        const bDate = new Date(b.lastActivity);
        return bDate - aDate;
      });
    setGridArray(photoArry);
    setPRSize(photoArry.length);

    if (widgetdata.length > 0) {
      const size = data.photoRecallData.photoRecallWidgets[0].GridSize;
      const value = data.photoRecallData.photoRecallWidgets[0].Layout.includes('Value');

      let parsedValue = JSON.parse(data.photoRecallData.photoRecallWidgets[0].Layout);
      if (value) {
        const doubleparsed = JSON.parse(parsedValue.Value);
        parsedValue = doubleparsed;
      }
      const config = data.photoRecallData.photoRecallWidgets[0].Configuration;

      switch (config) {
        case 1:
          setProps({ justify: 'center', bottom: '12vh' });
          break;
        case 2:
          setProps({ left: '40%' });
          break;
        case 3:
          setProps({ justify: 'center', bottom: '30vh' });
          break;
        case 4:
          setProps({});
          break;
        case 5:
          setProps({ justify: 'center', bottom: '12vh' });
          break;
        case 6:
          setProps({ left: '40%' });
          break;
        case 7:
          setProps({ justify: 'center', bottom: '30vh' });
          break;
        case 8:
          setProps({});
          break;
        case 9:
          setProps({});
          break;
        default:
          setProps({});
          break;
      }
      setPhotoRecallWidgets(data.photoRecallData.photoRecallWidgets[0]);
      setConfiguration(data.photoRecallData.photoRecallWidgets[0].Configuration);
      setLayouthandler(data.photoRecallData.photoRecallWidgets[0].Configuration);
      setPRID(data.photoRecallData.photoRecallWidgets[0].PhotoRecallID);
      setGridsize(data.photoRecallData.photoRecallWidgets[0].GridSize);
      setLayout(parsedValue);
      setPRSize(data.photoRecallData.photoRecallWidgets[0].PhotoRecallSize);
      if (data.photoRecallData.photoRecallWidgets[0].Configuration === 9) {
        setCustomGridSize(photoRecallWidgets.GridSize);
        setCustomField(true);
      }
    } else {
      setnewPRWidget(true);
      setGridsize(4);
      setLayout();
    }
  };

  const updatePRcompleted = (data) => {};

  const addwidgetscompleted = (data) => {
    setwID(data.addWebWidget.WidgetID);
    addPR();
  };

  const [getPRs] = useLazyQuery(GET_PRS, {
    onError: queryError,
    onCompleted: getWidgetscompleted,
  });

  const [addWidget] = useMutation(ADD_WIDGET, {
    variables: { widgetInput: widgetInput },
    onError: queryError,
    onCompleted: addwidgetscompleted,
  });

  const [addPR] = useMutation(ADD_PR, {
    variables: { widgetInputID: wID, photoRecallInput: PRwidgetInput },
    onError: queryError,
    onCompleted: updatePRcompleted,
  });

  const [updatePR] = useMutation(UPDATE_PR, {
    variables: { photoRecallID: prID, photoRecallInput: PRwidgetInput },
    onError: queryError,
    onCompleted: updatePRcompleted,
  });

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
  }

  // TODO: Implement GraphQL Subscriptions in next phase of photo recall
  // useEffect(() => {
  //   if (!exactTime) {
  //     const interval = setInterval(() => {
  //       setActivity(formatActivityTime(lastActivity, exactTime));
  //     }, 5000);
  //     return () => clearInterval(interval);
  //   }

  //   return () => {};
  // }, [activity, lastActivity, exactTime]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     refetch();
  //   }, 3000);
  //   return () => clearInterval(interval);
  // }, []);

  const handleSaveConfig = (e) => {
    setSnackBarOpen(true);
    const thislayout = JSON.stringify(gridlayout);
    const thisPRwidgetInput = {
      size: gridsize,
      config: configuration,
      photosize: prsize,
      layout: thislayout,
    };
    setPRWidgetInput(thisPRwidgetInput);
    if (newPRwidget) {
      const thiswidgetInput = {
        bookmarked: false,
        height: 4,
        width: 4,
        xPosition: 0,
        yPosition: 1,
        maxHeight: 10,
        maxWidth: 10,
        minHeight: 2,
        minWidth: 2,
        moveable: true,
        resizeable: true,
        widgetType: 0,
      };
      setwidgetInput(thiswidgetInput);
    }
  };

  const handleGridChange = (e) => {
    const gridconfig = e.target.value;
    setLayout();
    switch (gridconfig) {
      case 1:
        setGridsize(4);
        setConfiguration(1);
        setProps({ justify: 'center', bottom: '12vh' });
        break;

      case 2:
        setGridsize(4);
        setConfiguration(2);
        setProps({ left: '40%' });
        break;

      case 3:
        setGridsize(8);
        setConfiguration(3);
        setProps({ justify: 'center', bottom: '30vh' });
        break;

      case 4:
        setGridsize(8);
        setConfiguration(4);
        setProps({});
        break;

      case 5:
        setGridsize(8);
        setConfiguration(5);
        setProps({ justify: 'center', bottom: '12vh' });
        break;
      case 6:
        setGridsize(8);
        setConfiguration(6);
        setProps({ left: '40%' });
        break;
      case 7:
        setGridsize(16);
        setConfiguration(7);
        setProps({ justify: 'center', bottom: '30vh' });
        break;
      case 8:
        setGridsize(16);
        setConfiguration(8);
        setProps({});
        break;
      case 9:
        setGridsize(4);
        setCustomGridSize(4);
        setConfiguration(9);
        setProps({});
        break;

      default:
        setGridsize(16);
        setConfiguration(9);
        break;
    }
    setLayouthandler(gridconfig);
    if (gridconfig === 9) {
      setCustomField(true);
    } else {
      setCustomField(false);
    }
  };

  const handleCustomSize = (e) => {
    setGridsize(e.target.value);
    setConfiguration(9);
    setCustomGridSize(e.target.value);
    setLayout();
  };

  const handleCancel = (e) => {
    const value = photoRecallWidgets.Layout.includes('Value');

    let parsedValue = JSON.parse(photoRecallWidgets.Layout);
    if (value) {
      const doubleparsed = JSON.parse(parsedValue.Value);
      parsedValue = doubleparsed;
    }
    setConfiguration(photoRecallWidgets.Configuration);
    setLayouthandler(photoRecallWidgets.Configuration);
    setPRID(photoRecallWidgets.PhotoRecallID);
    setGridsize(photoRecallWidgets.GridSize);
    setLayout(parsedValue);
    setPRSize(photoRecallWidgets.PhotoRecallSize);
    if (photoRecallWidgets.Configuration === 9) {
      setCustomField(true);
      setCustomGridSize(photoRecallWidgets.GridSize);
    }
    renderGrid(parsedValue);
    refetch();
  };

  const renderGrid = (passed) => {
    const mutableWidgets = [];

    let photonum = 0;
    const size = Number(gridsize) + 1;
    if (layout) {
      let actualLayout = layout;
      if (passed) {
        actualLayout = passed;
      }

      var num = 0;
      const sizelayout = actualLayout.length;

      if (size - 1 === sizelayout) {
        var num = 0;
        actualLayout.map((block) => {
          num += 1;
          mutableWidgets.push(
            <div
              className={`${classes.widget}`}
              data-grid={{
                i: block.i,
                x: block.x,
                y: block.y,
                w: block.w,
                h: block.h,
                type: 'PhotoRecall',
                isResizable: block.isResizable,
                static: block.static,
                moved: block.moved,
              }}
              key={block.i}
              style={{
                backgroundColor: 'lightgrey',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              <div key={block.i} className={classes.imageContainer}>
                X
              </div>
            </div>
          );
        });
      }
    } else if (size) {
      switch (configuration) {
        case 1:
        case 3:
          for (let i = 1; i < size; i += 1) {
            const newKey = uuidv4();
            mutableWidgets.push(
              <div
                className={`${classes.widget}`}
                data-grid={{
                  i: newKey,
                  x: 0,
                  y: photonum,
                  w: 1,
                  h: 3,
                  type: 'PhotoRecall',
                  isResizable: false,
                  static: true,
                }}
                key={newKey}
                style={{
                  backgroundColor: 'lightgrey',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                }}
              >
                <div key={newKey} className={classes.imageContainer}>
                  X
                </div>
              </div>
            );
            photonum += 1;
          }
          photonum = 0;
          break;
        case 2:
        case 4:
          for (let i = 1; i < size; i += 1) {
            const newKey = uuidv4();
            mutableWidgets.push(
              <div
                className={`${classes.widget}`}
                data-grid={{
                  i: newKey,
                  x: photonum,
                  y: 0,
                  w: 1,
                  h: 3,
                  type: 'PhotoRecall',
                  isResizable: false,
                  static: false,
                }}
                key={newKey}
                style={{
                  backgroundColor: 'lightgrey',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                }}
              >
                <div key={newKey} className={classes.imageContainer}>
                  X
                </div>
              </div>
            );
            photonum += 1;
          }
          photonum = 0;
          break;
        case 5:
        case 7:
          for (let i = 1; i < size / 2; i += 1) {
            const newKey = uuidv4();
            mutableWidgets.push(
              <div
                className={`${classes.widget}`}
                data-grid={{
                  i: newKey,
                  x: 0,
                  y: photonum,
                  w: 1,
                  h: 3,
                  type: 'PhotoRecall',
                  isResizable: false,
                  static: true,
                }}
                key={newKey}
                style={{
                  backgroundColor: 'lightgrey',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                }}
              >
                <div key={newKey} className={classes.imageContainer}>
                  X
                </div>
              </div>
            );
            photonum += 1;
          }
          photonum = 0;
          for (let j = 1; j < size / 2; j += 1) {
            const newKey = uuidv4();
            mutableWidgets.push(
              <div
                className={`${classes.widget}`}
                data-grid={{
                  i: newKey,
                  x: 1,
                  y: photonum,
                  w: 1,
                  h: 3,
                  type: 'PhotoRecall',
                  isResizable: false,
                  static: true,
                }}
                key={newKey}
                style={{
                  backgroundColor: 'lightgrey',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                }}
              >
                <div key={newKey} className={classes.imageContainer}>
                  X
                </div>
              </div>
            );
            photonum += 1;
          }
          photonum = 0;
          break;
        case 6:
        case 8:
          for (let i = 1; i < size / 2; i += 1) {
            const newKey = uuidv4();
            mutableWidgets.push(
              <div
                className={`${classes.widget}`}
                data-grid={{
                  i: newKey,
                  x: photonum,
                  y: 0,
                  w: 1,
                  h: 3,
                  type: 'PhotoRecall',
                  isResizable: false,
                  static: true,
                }}
                key={newKey}
                style={{
                  backgroundColor: 'lightgrey',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                }}
              >
                <div key={newKey} className={classes.imageContainer}>
                  X
                </div>
              </div>
            );
            photonum += 1;
          }
          photonum = 0;
          for (let j = 1; j < size / 2; j += 1) {
            const newKey = uuidv4();
            mutableWidgets.push(
              <div
                className={`${classes.widget}`}
                data-grid={{
                  i: newKey,
                  x: photonum,
                  y: 3,
                  w: 1,
                  h: 3,
                  type: 'PhotoRecall',
                  isResizable: false,
                  static: true,
                }}
                key={newKey}
                style={{
                  backgroundColor: 'lightgrey',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                }}
              >
                <div key={newKey} className={classes.imageContainer}>
                  X
                </div>
              </div>
            );
            photonum += 1;
          }
          photonum = 0;
          break;
        case 9:
          if (size > 9) {
            for (let i = 1; i < size / 2; i += 1) {
              const newKey = uuidv4();
              mutableWidgets.push(
                <div
                  className={`${classes.widget}`}
                  data-grid={{
                    i: newKey,
                    x: photonum,
                    y: 0,
                    w: 1,
                    h: 3,
                    type: 'PhotoRecall',
                    isResizable: true,
                    static: false,
                  }}
                  key={newKey}
                  style={{
                    backgroundColor: 'lightgrey',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                  }}
                >
                  <div key={newKey} className={classes.imageContainer}>
                    X
                  </div>
                </div>
              );
              photonum += 1;
            }
            photonum = 0;
            for (let j = 1; j < size / 2; j += 1) {
              const newKey = uuidv4();
              mutableWidgets.push(
                <div
                  className={`${classes.widget}`}
                  data-grid={{
                    i: newKey,
                    x: photonum,
                    y: 3,
                    w: 1,
                    h: 3,
                    type: 'PhotoRecall',
                    isResizable: true,
                    static: false,
                  }}
                  key={newKey}
                  style={{
                    backgroundColor: 'lightgrey',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                  }}
                >
                  <div key={newKey} className={classes.imageContainer}>
                    X
                  </div>
                </div>
              );
              photonum += 1;
            }
            photonum = 0;
          } else {
            for (let i = 1; i < size; i += 1) {
              const newKey = uuidv4();
              mutableWidgets.push(
                <div
                  className={`${classes.widget}`}
                  data-grid={{
                    i: newKey,
                    x: photonum,
                    y: 0,
                    w: 1,
                    h: 3,
                    type: 'PhotoRecall',
                    isResizable: true,
                    static: false,
                  }}
                  key={newKey}
                  style={{
                    backgroundColor: 'lightgrey',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                  }}
                >
                  <div key={newKey} className={classes.imageContainer}>
                    X
                  </div>
                </div>
              );
              photonum += 1;
            }
          }

          break;
        default:
          break;
      }
    } else {
      for (let i = 1; i < 5; i += 1) {
        const newKey = uuidv4();
        mutableWidgets.push(
          <div
            className={`${classes.widget}`}
            data-grid={{
              i: newKey,
              x: 0,
              y: photonum,
              w: 1,
              h: 3,
              type: 'PhotoRecall',
              isResizable: false,
              static: true,
            }}
            key={newKey}
            style={{
              backgroundColor: 'lightgrey',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            <div key={newKey} className={classes.imageContainer}>
              X
            </div>
          </div>
        );
        photonum += 1;
      }
      photonum = 0;
    }

    return mutableWidgets;
  };

  const onLayoutChange = (layout) => {
    gridlayout = layout;
    const blocks = [];
    layout.map((block) => {
      blocks.push({
        i: block.i,
        x: block.x,
        y: block.y,
        w: block.w,
        h: block.h,
        type: 'PhotoRecall',
        isResizable: block.isResizable,
        static: block.static,
        moved: configuration === 9,
      });
    });

    gridlayout = layout;
  };

  return (
    <>
      <ButtonHeader title="Photo Recall Configuration" />
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
        <Link color="inherit" href="/admin">
          Administration
        </Link>
        <Link color="inherit" href="/globalsettings/globalSetting">
          Global Settings
        </Link>
        <Typography color="textPrimary">Photo Recall</Typography>
      </Breadcrumbs>
      <br />
      <div className={classes.content}>
        <Paper className={classes.paper} square>
          <Grid container direction="row" justify="space-evenly" alignItems="stretch">
            <Grid item sm={5} className={classes.gridleft} elevation={3}>
              <p>
                You can use this area to edit the configuration in Photo Recall. A Preview of the
                configuration can be seen. You may save this configuration using the button below. A
                list of default layout options are in the drop down below. Hitting Cancel will bring
                up your saved configuration if you had one previously.
                <br />
                <br />
              </p>

              <br />

              <div className={classes.form}>
                <Grid container spacing={3}>
                  <Grid item xs={9}>
                    <FormControl variant="outlined" className={classes.textBoxcombo} fullWidth>
                      <InputLabel shrink style={{ backgroundColor: 'white' }}>
                        Select Configuration:{' '}
                      </InputLabel>
                      <Select
                        autoWidth
                        value={layouthandler}
                        onChange={handleGridChange}
                        className={classes.header}
                        defaultValue={configuration}
                      >
                        <MenuItem value={1}>1 x 4 grid</MenuItem>
                        <MenuItem value={2}>4 x 1 grid</MenuItem>
                        <MenuItem value={3}>1 x 8 grid</MenuItem>
                        <MenuItem value={4}>8 x 1 grid</MenuItem>
                        <MenuItem value={5}>2 x 4 grid</MenuItem>
                        <MenuItem value={6}>4 x 2 grid</MenuItem>
                        <MenuItem value={7}>2 x 8 grid</MenuItem>
                        <MenuItem value={8}>8 x 2 grid</MenuItem>
                        <MenuItem value={9}>Custom</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  {customField ? (
                    <>
                      <Grid item xs={9}>
                        <FormControl variant="outlined" className={classes.textBoxcombo} fullWidth>
                          <InputLabel shrink style={{ backgroundColor: 'white' }}>
                            Select Custom Layout Size:
                          </InputLabel>
                          <Select
                            autoWidth
                            value={customGridSize ?? 4}
                            onChange={handleCustomSize}
                            className={classes.header}
                            defaultValue={4}
                          >
                            <MenuItem value={4}>4</MenuItem>
                            <MenuItem value={8}>8</MenuItem>
                            <MenuItem value={12}>12</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </>
                  ) : null}
                </Grid>
                <br />
              </div>

              <Grid container spacing={2}>
                <Grid item sm={2}>
                  <Button
                    onClick={handleSaveConfig}
                    variant="contained"
                    style={{ margin: 'auto' }}
                    color="primary"
                  >
                    Save
                  </Button>
                </Grid>
                <Grid item sm={4}>
                  <Button
                    onClick={handleCancel}
                    variant="contained"
                    style={{ margin: 'auto' }}
                    color="default"
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={6} className={classes.gridright}>
              <ResponsiveGridLayout
                cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
                rows={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
                onLayoutChange={onLayoutChange}
                autosize
                onBreakpointChange={() => {}}
                rowHeight={30}
                width={1000}
                compactType={null}
              >
                {renderGrid()}
              </ResponsiveGridLayout>
              <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={snackBarOpen}
                className={classes.snackbar}
                autoHideDuration={2000}
                onClose={handleSnackBarClose}
              >
                <Alert onClose={handleSnackBarClose} severity="success">
                  Photo Recall Configuration Saved
                </Alert>
              </Snackbar>
            </Grid>
          </Grid>
        </Paper>
      </div>
    </>
  );
};

export default PhotoRecall;
